import { OrderStatusEnum } from 'types/graphql';
import { ThresholdLevel } from 'pages/ReportsPage/components/AnalyticsDashboards/chartColors';

export const FULFILLED_STATUSES: string[] = [
  OrderStatusEnum.accepted,
  OrderStatusEnum.assigned,
  OrderStatusEnum.in_progress,
  OrderStatusEnum.completed,
  OrderStatusEnum.swapped,
];

export const UNFILLED_STATUSES: string[] = [
  OrderStatusEnum.pending,
  'open',
  OrderStatusEnum.requested,
  OrderStatusEnum.unfulfilled,
  OrderStatusEnum.absent,
  OrderStatusEnum.rejected,
  'scheduled',
];

export const CANCELLED_STATUSES: string[] = [OrderStatusEnum.cancelled];

export const FULFILLMENT_THRESHOLDS = {
  [ThresholdLevel.ON_TARGET]: { min: 85 },
  [ThresholdLevel.MONITOR]: { min: 75, max: 84 },
  [ThresholdLevel.ATTENTION]: { min: 65, max: 74 },
  [ThresholdLevel.CRITICAL]: { max: 64 },
} as const;

export function getThresholdLevel(fulfillmentPercentage: number): ThresholdLevel {
  if (fulfillmentPercentage >= 85) return ThresholdLevel.ON_TARGET;
  if (fulfillmentPercentage >= 75) return ThresholdLevel.MONITOR;
  if (fulfillmentPercentage >= 65) return ThresholdLevel.ATTENTION;
  return ThresholdLevel.CRITICAL;
}

export function getThresholdColor(
  level: ThresholdLevel,
  thresholdColors: { onTarget: string; monitor: string; attention: string; critical: string },
): string {
  switch (level) {
    case ThresholdLevel.ON_TARGET:
      return thresholdColors.onTarget;
    case ThresholdLevel.MONITOR:
      return thresholdColors.monitor;
    case ThresholdLevel.ATTENTION:
      return thresholdColors.attention;
    case ThresholdLevel.CRITICAL:
      return thresholdColors.critical;
  }
}

export const SHIFT_STATUS_CATEGORIES = [
  { key: 'assigned', i18nKey: 'reports:SHIFT_STATUS_ASSIGNED' },
  { key: 'fulfilled_callout', i18nKey: 'reports:SHIFT_STATUS_FULFILLED_CALLOUT' },
  { key: 'upcoming_callout', i18nKey: 'reports:SHIFT_STATUS_UPCOMING_CALLOUT' },
  { key: 'fulfilled_bid_award', i18nKey: 'reports:SHIFT_STATUS_FULFILLED_BID_AWARD' },
  { key: 'pending', i18nKey: 'reports:SHIFT_STATUS_PENDING' },
  { key: 'unfulfilled', i18nKey: 'reports:SHIFT_STATUS_UNFULFILLED' },
  { key: 'cancelled', i18nKey: 'reports:SHIFT_STATUS_CANCELLED' },
  { key: 'absent', i18nKey: 'reports:SHIFT_STATUS_ABSENT' },
] as const;

export type ShiftStatusKey = typeof SHIFT_STATUS_CATEGORIES[number]['key'];

export const SHIFT_BREAKDOWN_COLOR_INDICES: Record<string, number> = {
  assigned: 3,
  fulfilled_callout: 0,
  upcoming_callout: -2,
  fulfilled_bid_award: 2,
  pending: 4,
  unfulfilled: -1,
  cancelled: 7,
  absent: 5,
};

export const OVERVIEW_DASHBOARD_PATH = '/reports/overview';

export const TREND_DAILY_THRESHOLD_DAYS = 14;
